import styled from "styled-components";
import { breakpoints } from "../../../../shared-logic/themes/lexusTheme";

export const VehicleInformationMobileWrapper = styled.div`
    @media screen and (min-width: ${breakpoints.xl}) {
        display: none;
    }
`;

export const CarouselDisclaimer = styled.div`
    padding-block-end: var(--spacing-3);
    text-align: center;

    @media screen and (min-width: ${breakpoints.xl}) {
        padding-block-end: 0;
    }
`;
